import {clone} from 'ramda'
import all from './all'

export default {
  ...clone(all),
  intercomId: 'sgsczvgp',
  id: 'production',
}
